import { Route } from '@angular/router';
import { AuthGuard } from '../../shared/services';
import { UserListRoutes } from './user-list/user-list.routes';
import { UserDetailsRoutes } from './user-details/user-details.routes';
import { UserEditionRoutes } from './user-edition/user-edition.routes';
import { AdminEditionRoutes } from './admin-edition/admin-edition.routes';
import { UsersComponent } from './users.component';

export const UsersRoutes: Route[] = [
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [AuthGuard],
    children: [
      ...UserListRoutes,
      ...UserDetailsRoutes,
      ...UserEditionRoutes,
      ...AdminEditionRoutes
    ]
  }
];
